<div class="segmented-toggle" [class.is-disabled]="disabled" role="tablist" [attr.aria-label]="ariaLabel">
  @for (option of options; track option.id) {
    <button
      type="button"
      role="tab"
      [class.active]="activeId === option.id"
      [class.disabled]="!!option.disabled"
      [disabled]="!!option.disabled"
      [attr.aria-selected]="activeId === option.id"
      [matTooltip]="option.tooltip ?? null"
      (click)="onSelect(option)"
    >
      @if (showActiveCheckIcon && activeId === option.id) {
        <span class="active-check" aria-hidden="true">✓</span>
      } @else if (option.icon) {
        <mat-icon>{{ option.icon }}</mat-icon>
      }
      <span>{{ option.label }}</span>
    </button>
  }
</div>
